import Model from "backdraft-app/src/model";

import _ from "underscore";

export default class CustomDataField extends Model {
  initialize() {
    this.set('inheritedValue', this._getInheritedValueFromModalReference());
  }

  _getInheritedValueFromModalReference() {
    if (this.get("modalReference")) {
      const inheritdData = this.get('modalReference').get('inherited_custom_data') || {};
      return inheritdData[this.get('fieldPartnerName')] || {};
    } else {
      return {};
    }
  }

  getFieldValues() {
    if (this.get("modalReference")) {
      const fieldValues = this.get('modalReference').get('customFieldValuePairs').get('fieldValues');
      if (fieldValues[this.get('fieldPartnerName')]) {
        return fieldValues[this.get('fieldPartnerName')].get("fieldValues");
      }
    }
  }

  _getField() {
    const field = {};
    field[this.get("fieldPartnerName")] = this.get("fieldValue");
    return field;
  }

  validate(attr, options) {
    this.unset("errors");
    this.errors = {};
    this._validatePartnerName(attr);
    switch (this.get('dataType')) {
    case 'string':
      this._validateStringField(attr);
      break;
    case 'url':
      this._validateUrlField(attr);
      break;
    case 'business_object':
      this._validateBusinessObjectField(attr);
      break;
    }
    this.set('errors', this.errors);

    if (!_.isEmpty(this.errors)) {
      this.get('modalReference').set('valid', false);
      return this.errors;
    } else {
      this.get('modalReference').set('valid', true);
    }
  }

  _validateStringField(attr) {
    if (attr.fieldValue.length > 255) {
      this.errors.fieldValue = "Value exceeds 255 character limit for this field.";
    }
    this._validatePresenceOfFieldValues(attr);
  }

  _validateUrlField(attr) {
    if (attr.fieldValue.length > 10000) {
      this.errors.fieldValue = "Value exceeds 10,000 character limit for this field.";
    }
    this._validatePresenceOfFieldValues(attr);
  }

  _validateBusinessObjectField(attr) {
    if (attr.fieldValue.length > 255) {
      this.errors.fieldValue = "Value exceeds 255 character limit for this field.";
    }
    this._validatePresenceOfFieldValues(attr);
  }

  _validatePartnerName({ fieldPartnerName }) {
    if (fieldPartnerName.length === 0) {
      this.errors.fieldPartnerName = "Name must be selected.";
    }
  }

  _validatePresenceOfFieldValues({ fieldValue }) {
    if (fieldValue.trim().length === 0) {
      this.errors.fieldValue = "Value can't be blank.";
    }
  }

  toJSON() {
    return this._getField();
  }
}
